import { Button, IconButton, TextField, Typography } from "@mui/material";
import { Helmet } from "react-helmet"
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import { useState } from "react";
import { colors } from "styles/colors";
import { useNavigate } from "react-router-dom";
import { useDispatch} from "react-redux";
import { get, post } from "api/apiBridges/httpBridge";
import { ffetch as fetch, }  from '../api/customHttp';
import { loginUser} from '../store/slices/loginSlice';
import { useLocalNotifications } from "components/Events";

const color1 = "#c2ded3";
const color2 = "#b9d9e6";

const Register = () => {

    let name;

    let password;
    let phone;
    let repeat_password;
    let inn;
    let companyName;

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const [repeat_showPassword, repeat_setShowPassword] = useState(false);

    const handleClickRepeatShowPassword = () => repeat_setShowPassword((show) => !show);

    const handleMouseDownRepeatPassword = (event) => {
        event.preventDefault();
    };

    const changeName = (val) => {
        name = val
    }
    
    const changePassword = (val) => {
        password = val
    }
    const changePhone = (val) => {
        phone = val
    }
    const changeRepeat_password = (val) => {
        repeat_password = val
    }
    const changeInn = (val) => {
        inn = val
    }
    const changeCompanyName = (val) => {
        companyName = val
    }

    const { showNotification } = useLocalNotifications();

    const habdleClickReg = async () => {
        let check = await get("Registration/checkAuth", {login: phone})
        if (!check) {
            console.log(name, password, phone, repeat_password, inn, companyName)
            let compResp = await post('Registration/addCompany', {"name":companyName,"inn":inn})
            console.log(await post('Registration/addAdmin', 
                {"userInfo": 
                    {
                        "fio":`${name}`,
                        "email":"", 
                        "mobile_number":phone,
                        "company_id": compResp.message
                    },
                "authinfo":{"login":phone, "password":password}
                }
                )
            )
            //Получаем токен
            fetch(`${process.env.REACT_APP_DEV_HOST_CORE}/auth/login`, {
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
                body: JSON.stringify({username:phone, password:password}),
                method: 'POST',
                }).then(async res => {
                    const data = await res.json();
                    console.log("data>>>>>>>>>>>>>>>>>>>", data)
                    if (data.accessToken ){
                    localStorage.setItem('access_token', data.accessToken);
                    localStorage.setItem('refresh_token', data.refreshToken);
                    dispatch(loginUser(data));
                    navigate('/home');
                    }
            })
        }
        else {
            showNotification({
            id: 'errorCreateNode', 
            type: 'error', 
            message: 'Пользователь с таким номером уже зарегестрирован' 
            });
        }

    }

    return (
        <>
            <Helmet>
                <title>Registration</title>
            </Helmet>
            <div style={{ position: 'fixed', background: `linear-gradient(90deg, ${color1}, ${color2})`, width: '100%', height: '100%' }}>
                <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                    <div style={{ paddingTop: '20px', paddingBottom: '20px', background: "#ffffff", display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignContent: "center", flexWrap: 'nowrap', minWidth: '200px', borderRadius: '15px' }}>
                        <Typography style={{ textAlign: "center" }} color="text.secondary" variant="h2">Регистрация</Typography>
                        <div style={{ width: '100%', paddingLeft: '15%', paddingRight: '15%', marginTop: '20px', marginBottom: '20px' }}>
                            
                            <TextField inputProps={{ maxLength: 80 }} id="name" label="Имя" variant="outlined" style={{ width: '100%', borderRadius: '18px', marginBottom: '20px' }} value={name} onChange={(e) => changeName(e.target.value)}/>
                            
                            <TextField inputProps={{ maxLength: 80 }} id="phone" label="Телефон" variant="outlined" style={{ width: '100%', borderRadius: '18px', marginBottom: '20px' }} value={phone} onChange={(e) => changePhone(e.target.value)}/>
                            <TextField inputProps={{ maxLength: 80 }} id="inn" label="ИНН" variant="outlined" style={{ width: '100%', borderRadius: '18px', marginBottom: '20px' }} value={inn} onChange={(e) => changeInn(e.target.value)}/>
                            <TextField inputProps={{ maxLength: 80 }} id="company_name" label="Имя компании" variant="outlined" style={{ width: '100%', borderRadius: '18px', marginBottom: '20px' }} value={companyName} onChange={(e) => changeCompanyName(e.target.value)}/>
                            <TextField id="password" label="Пароль" variant="outlined" style={{ width: '100%', borderRadius: '18px', marginBottom: '20px' }} value={password}
                                onChange={(e) => changePassword(e.target.value)}
                                type={showPassword ? 'text' : 'password'}
                                inputProps={{ maxLength: 80 }}
                                InputProps={{
                                    endAdornment: (
                                        <div>
                                            <IconButton
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </div>
                                    )
                                }}
                            />

                            <TextField id="repeat_password" label="Повторите пароль" variant="outlined" style={{ width: '100%', borderRadius: '18px' }} value={repeat_password}
                                onChange={(e) => changeRepeat_password(e.target.value)}
                                type={showPassword ? 'text' : 'password'}
                                inputProps={{ maxLength: 80 }}
                                InputProps={{
                                    endAdornment: (
                                        <div>
                                            <IconButton
                                                onClick={handleClickRepeatShowPassword}
                                                onMouseDown={handleMouseDownRepeatPassword}
                                            >
                                                {repeat_showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </div>
                                    )
                                }}
                            />
                        </div>
                        <>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginBottom: '10px' }}>
                                <span >{`Уже есть аккаунт?\u2002`}</span>
                                <a href="http://localhost:3000/login" style={{ textTransform: 'none', textDecoration: 'underline', color: colors.elements }}>Войти</a>
                            </div>
                            <div style={{ width: '100%', paddingLeft: '25%', paddingRight: '25%' }}>
                                <Button onClick={habdleClickReg} style={{ width: '100%', maxHeight: '40px', background: colors.elements, color: 'white', fontWeight: 'bold' }}>Зарегистрироваться</Button>
                            </div>
                        </>
                    </div>

                </div>
            </div>

        </>
    );
}

export default Register;